import React from 'react';
import PropTypes from 'prop-types';

import CCSContentSwitcher from '@ey/canvascoreservices/ContentSwitcher';

const ContentSwitcher = ({...props}) => <CCSContentSwitcher {...props} />;

ContentSwitcher.propTypes = {};

export default ContentSwitcher;
